import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  copyToArray2j022khrow2yi as copyToArray,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  uppercaseChar6lahngw3wvwg as uppercaseChar,
  Char19o2r8palgjof as Char,
  Unit_instanceat14thlj150z as Unit_instance,
  toString14fd7g605f91p as toString_0,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  enumEntries20mr21zbe3az4 as enumEntries,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Enum3alwj03lh1n41 as Enum,
  abs1kdzbjes1idip as abs,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  isIntArrayeijsubfngq38 as isIntArray,
  listOf1jh22dvmctj1r as listOf,
  until1jbpn0z3f8lbg as until,
  joinToString1cxrrlmo0chqs as joinToString,
  ArrayList3it5z8td81qkl as ArrayList,
  plus310ted5e4i90h as plus,
  emptySetcxexqki71qfa as emptySet,
  toSet2orjxp16sotqu as toSet,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  getKClass1s3j9wy1cofik as getKClass,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  KClass1cc9rfeybg8hs as KClass,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  numberToDouble210hrknaofnhf as numberToDouble,
  toList383f556t1dixk as toList,
  emptyList1g2z5xcrvp2zy as emptyList,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toString30pk9tzaqopn as toString_1,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  get_EmptyContinuationn1rwa6yr6j5w as get_EmptyContinuation,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
} from './kotlin-kotlin-stdlib.mjs';
import {
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  Resources1ysf2j4wd5yk7 as Resources,
  launchImmediatelylnv8lnistpdy as launchImmediately,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  readAtlas3i3fpdxd2wy0v as readAtlas,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  get_DefaultTtfFontAsBitmap1hzwi8e4truhb as get_DefaultTtfFontAsBitmap,
  Companion_getInstancezw1wxvwtmh0g as Companion_getInstance,
  get_DefaultStringTextRendererdyzggul2pyry as get_DefaultStringTextRenderer,
  RGBA__withAd_impl_cralao1ojb8pkalp2nb as RGBA__withAd_impl_cralao,
  Bitmaps_instance27726euemn90u as Bitmaps_instance,
  get_Bitmaps_transparent3nm2857y3u3hn as get_Bitmaps_transparent,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  Companion_instancelqpzd9anuk16 as Companion_instance,
  IntArray23680o40e0fgt8 as IntArray2,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Vector2I2k5512l4eeahb as Vector2I,
  toFloat3vwgbpbd3tigk as toFloat,
  Vector2F2yb91r49vy4m7 as Vector2F,
  toInt1pmw4ml9b064d as toInt,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstanceeqp3ibr2vvu9 as Companion_getInstance_0,
  div919pico60rxu as div,
  toIntu0rc68akxu7a as toInt_0,
  toDouble2d46ijanub8on as toDouble,
  timesatqrmkwmiu2z as times,
  Vector2D378fe5rov8fgw as Vector2D,
  Companion_getInstance1j5nd3fbu9uao as Companion_getInstance_1,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import { get_unreachable2fi7msfg0vgzd as get_unreachable } from './korlibs-platform-root-korlibs-platform.mjs';
import {
  Korge3fi4cwjkh8up9 as Korge,
  SceneContainer99ijjqni12hp as SceneContainer,
  Companion_getInstance2b4rje0hs8ulh as Companion_getInstance_2,
  Scenezu810y12qpqp as Scene,
  UIVerticalStack2gichhwk4pg3x as UIVerticalStack,
  addTo25e29vq105prw as addTo,
  Companion_getInstancequ1o8fwft10r as Companion_getInstance_3,
  UIButton259u54yn72ttw as UIButton,
  get_mouse1jstwhfaumelj as get_mouse,
  xy1gb51vhy014mx as xy,
  SolidRect131p7hyzlx7j8 as SolidRect,
  Container7486fjmip554 as Container,
  Companion_instance1qzytx5vkv693 as Companion_instance_0,
  Text3kimhvgfxflj3 as Text,
  Companion_getInstance347d6rnwg0m6u as Companion_getInstance_4,
  DropshadowFilter3mmze965vo4ad as DropshadowFilter,
  get_filterScaleuvlwz3cded4n as get_filterScale,
  Companion_instancemwhzkt5i9y3h as Companion_instance_1,
  set_filter36wgvpm5cukpc as set_filter,
  set_filterScale3iptc9lhu4vp1 as set_filterScale,
  Image1b2d7ghyim7p5 as Image,
  UIHorizontalStack2hv4gvky7dghi as UIHorizontalStack,
  MouseEvents19mapgq8ez76g as MouseEvents,
  xyssniz4rympby as xy_0,
  PixelatedSceneoudxoze5iszc as PixelatedScene,
  centerOnqo5dp4jcubi5 as centerOn,
  get_centeredilxldnbf7ma6 as get_centered,
  scalea9fc0mbrr7ub as scale,
  alphaher384qrj9q4 as alpha,
  draggable20qgpvq8etapv as draggable,
  get_AlphaTransition23l7sd982osvm as get_AlphaTransition,
  withEasingtnol1eyyo9sf as withEasing,
  views116j359zi8nvf as views,
  findFirstAscendante8nli1jx4t64 as findFirstAscendant,
  FixedSizeContainersre0rworj71w as FixedSizeContainer,
  Stage1ggtrzujnnkl0 as Stage,
} from './korge-root-korge.mjs';
import { Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance } from './korlibs-logger-root-korlibs-logger.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  get_isEven24nr2rw87dlfj as get_isEven,
  Companion_getInstance3gvjtadf9ot2d as Companion_getInstance_5,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import { get_EASE_IN_OUT_QUAD21w3u6e1aoexb as get_EASE_IN_OUT_QUAD } from './korlibs-math-root-korlibs-math.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class KR {}
function get_gfx() {
  return KRGfx_instance;
}
class KR_0 {}
class KRGfx {
  fcu() {
    return _TypedAtlas___init__impl__rehbr4(get_resourcesVfs().yh('gfx/chess_shadow.atlas.json'));
  }
}
class AtlasGfxChessShadowAtlas {
  constructor(__atlas) {
    this.gcu_1 = __atlas;
  }
  toString() {
    return AtlasGfxChessShadowAtlas__toString_impl_2uvypk(this.gcu_1);
  }
  hashCode() {
    return AtlasGfxChessShadowAtlas__hashCode_impl_om1vif(this.gcu_1);
  }
  equals(other) {
    return AtlasGfxChessShadowAtlas__equals_impl_lio65n(this.gcu_1, other);
  }
}
class Companion {
  constructor() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = get_entries();
    tmp.hcu_1 = copyToArray(this_0);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_entries();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.ac(capacity);
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'Companion.UPPER_KEYS.<anonymous>' call
      var tmp$ret$1 = new Char(uppercaseChar(element.mcu_1));
      destination.c3(tmp$ret$1, element);
    }
    tmp_0.icu_1 = destination;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_2 = get_entries();
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.ac(capacity_0);
    var tmp0_iterator_0 = this_2.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'Companion.LOWER_KEYS.<anonymous>' call
      // Inline function 'kotlin.text.lowercaseChar' call
      // Inline function 'kotlin.text.lowercase' call
      var this_3 = element_0.mcu_1;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$6 = toString_0(this_3).toLowerCase();
      var tmp$ret$7 = charSequenceGet(tmp$ret$6, 0);
      var tmp$ret$8 = new Char(tmp$ret$7);
      destination_0.c3(tmp$ret$8, element_0);
    }
    tmp_1.jcu_1 = destination_0;
  }
}
class ChessPieceKind extends Enum {
  constructor(name, ordinal, key, index) {
    super(name, ordinal);
    this.mcu_1 = key;
    this.ncu_1 = index;
  }
}
class ChessPlayer extends Enum {
  qcu() {
    return this.rcu() ? ChessPlayer_WHITE_getInstance() : ChessPlayer_BLACK_getInstance();
  }
  rcu() {
    return this.equals(ChessPlayer_BLACK_getInstance());
  }
  scu() {
    return this.rcu() ? 1 : -1;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_3 = this;
    this.tcu_1 = new Empty();
  }
  ucu(value) {
    if (value === 0)
      return this.tcu_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var kindIndex = abs(value) - 1 | 0;
    var kind = Companion_getInstance_6().hcu_1[kindIndex];
    var player = value > 0 ? ChessPlayer_BLACK_getInstance() : ChessPlayer_WHITE_getInstance();
    return new Piece(kind, player);
  }
}
class ChessCell {}
function get_isEmpty() {
  return equals(this, Companion_getInstance_7().tcu_1);
}
function get_kind() {
  return null;
}
function get_player() {
  return null;
}
class Empty {
  constructor() {
    this.vcu_1 = 0;
  }
  wcu() {
    return _Char___init__impl__6a9atx(46);
  }
  toString() {
    return toString_0(this.wcu());
  }
}
class Piece {
  constructor(kind, player) {
    this.acv_1 = kind;
    this.bcv_1 = player;
    this.ccv_1 = imul(this.acv_1.ncu_1 + 1 | 0, this.bcv_1.scu());
  }
  ycu() {
    return this.acv_1;
  }
  zcu() {
    return this.bcv_1;
  }
  wcu() {
    var tmp;
    switch (this.bcv_1.l3_1) {
      case 0:
        tmp = uppercaseChar(this.acv_1.mcu_1);
        break;
      case 1:
        // Inline function 'kotlin.text.lowercaseChar' call

        // Inline function 'kotlin.text.lowercase' call

        var this_0 = this.acv_1.mcu_1;
        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        var tmp$ret$2 = toString_0(this_0).toLowerCase();
        tmp = charSequenceGet(tmp$ret$2, 0);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  toString() {
    return toString_0(this.wcu());
  }
  hashCode() {
    var result = this.acv_1.hashCode();
    result = imul(result, 31) + this.bcv_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Piece))
      return false;
    var tmp0_other_with_cast = other instanceof Piece ? other : THROW_CCE();
    if (!this.acv_1.equals(tmp0_other_with_cast.acv_1))
      return false;
    if (!this.bcv_1.equals(tmp0_other_with_cast.bcv_1))
      return false;
    return true;
  }
}
class Companion_1 {
  dcv() {
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var tmp = 0;
    var tmp_0 = imul(8, 8);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      // Inline function 'Companion.createEmpty.<anonymous>' call
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var tmp$ret$2 = new IntArray2(8, 8, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    return _ChessBoard___init__impl__tmwo79(tmp$ret$2);
  }
  ecv() {
    var array = _ChessBoard___get_array__impl__75hq55(this.dcv()).kx();
    var _iterator__ex2g4s = listOf([ChessPlayer_BLACK_getInstance(), ChessPlayer_WHITE_getInstance()]).a1();
    while (_iterator__ex2g4s.b1()) {
      var player = _iterator__ex2g4s.c1();
      var pawn = new Piece(ChessPieceKind_PAWN_getInstance(), player);
      var rook = new Piece(ChessPieceKind_ROOK_getInstance(), player);
      var knight = new Piece(ChessPieceKind_KNIGHT_getInstance(), player);
      var bishop = new Piece(ChessPieceKind_BISHOP_getInstance(), player);
      var queen = new Piece(ChessPieceKind_QUEEN_getInstance(), player);
      var king = new Piece(ChessPieceKind_KING_getInstance(), player);
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          array.u2i(n, createDefault$getY(player, 1), pawn.ccv_1);
        }
         while (inductionVariable < 8);
      array.u2i(0, createDefault$getY(player, 0), rook.ccv_1);
      array.u2i(1, createDefault$getY(player, 0), knight.ccv_1);
      array.u2i(2, createDefault$getY(player, 0), bishop.ccv_1);
      array.u2i(3, createDefault$getY(player, 0), queen.ccv_1);
      array.u2i(4, createDefault$getY(player, 0), king.ccv_1);
      array.u2i(5, createDefault$getY(player, 0), bishop.ccv_1);
      array.u2i(6, createDefault$getY(player, 0), knight.ccv_1);
      array.u2i(7, createDefault$getY(player, 0), rook.ccv_1);
    }
    return _ChessBoard___init__impl__tmwo79(array);
  }
}
class ChessBoard {
  constructor(array) {
    this.fcv_1 = array;
  }
  toString() {
    return ChessBoard__toString_impl_odpisb(this.fcv_1);
  }
  hashCode() {
    return ChessBoard__hashCode_impl_2mjlzg(this.fcv_1);
  }
  equals(other) {
    return ChessBoard__equals_impl_5zlns(this.fcv_1, other);
  }
}
class MainMenuScene$sceneMain$lambda$slambda {
  constructor(this$0) {
    this.hcv_1 = this$0;
  }
  u1n($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class MainMenuScene extends Scene {
  za7(_this__u8e3s4, $completion) {
    // Inline function 'korlibs.korge.view.xy' call
    // Inline function 'korlibs.korge.ui.uiVerticalStack' call
    // Inline function 'kotlin.apply' call
    var this_0 = addTo(UIVerticalStack.cb8(null, 0.0, false), _this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'MainMenuScene.sceneMain.<anonymous>' call
    // Inline function 'korlibs.korge.input.onClick' call
    // Inline function 'korlibs.korge.ui.uiButton' call
    var label = 'START GAME!';
    var size = Companion_getInstance_3().eao_1;
    // Inline function 'kotlin.apply' call
    var this_1 = addTo(UIButton.say(size, label, null), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.uiButton.<anonymous>' call
    var handler = MainMenuScene$sceneMain$lambda(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop = click$factory();
    var tmp1_safe_receiver = this_1 == null ? null : this_1.gaj();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < tmp1_safe_receiver.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
        var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
        if (tmp1_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp = prop.get(tmp1_safe_receiver_0);
          tmp.p1v(MainMenuScene$sceneMain$lambda_0(handler));
        }
      }
    }
    // Inline function 'korlibs.korge.input.onClick' call
    // Inline function 'korlibs.korge.ui.uiButton' call
    var label_0 = 'EXIT GAME!';
    var size_0 = Companion_getInstance_3().eao_1;
    // Inline function 'kotlin.apply' call
    var this_2 = addTo(UIButton.say(size_0, label_0, null), this_0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.uiButton.<anonymous>' call
    var handler_0 = MainMenuScene$sceneMain$lambda_1(this);
    // Inline function 'korlibs.korge.input.doMouseEvent' call
    var prop_0 = click$factory_0();
    var tmp1_safe_receiver_1 = this_2 == null ? null : this_2.gaj();
    if (tmp1_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n_0 = 0;
      while (n_0 < tmp1_safe_receiver_1.e1()) {
        // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var tmp0_safe_receiver_0 = tmp1_safe_receiver_1.d1(_unary__edvuaz_0);
        var tmp1_safe_receiver_2 = tmp0_safe_receiver_0 == null ? null : get_mouse(tmp0_safe_receiver_0);
        if (tmp1_safe_receiver_2 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          var tmp_0 = prop_0.get(tmp1_safe_receiver_2);
          tmp_0.p1v(MainMenuScene$sceneMain$lambda_2(handler_0));
        }
      }
    }
    xy(this_0, numberToDouble(256), numberToDouble(256));
  }
}
class GameScene$sceneMain$slambda {
  constructor(this$0) {
    this.scv_1 = this$0;
  }
  a9w(it, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, it), $completion);
  }
  od(p1, $completion) {
    return this.a9w(p1 instanceof MouseEvents ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene$sceneMain$lambda$slambda {
  constructor($handler, $it) {
    this.tcv_1 = $handler;
    this.ucv_1 = $it;
  }
  nd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class GameScene$redrawBoard$lambda$slambda {
  constructor(this$0) {
    this.vcv_1 = this$0;
  }
  u1n($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
  }
  od(p1, $completion) {
    return this.u1n((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class GameScene extends PixelatedScene {
  constructor() {
    super(1024, 1024, VOID, VOID, true);
    this.lcw_1 = Companion_instance_4.ecv();
    this.mcw_1 = ChessPlayer_WHITE_getInstance();
  }
  bcx(value) {
    this.lcw_1 = value;
    this.wcw();
  }
  acx(currentPlayer, board) {
    this.mcw_1 = currentPlayer;
    this.bcx(board);
  }
  vcw() {
    var tmp = this.ncw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('boardContainer');
    }
  }
  zcw() {
    var tmp = this.ocw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('placeholderContainer');
    }
  }
  ccx() {
    var tmp = this.pcw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('piecesContainer');
    }
  }
  dcx() {
    var tmp = this.qcw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('overlayContainer');
    }
  }
  y5p() {
    var tmp = this.rcw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('text');
    }
  }
  xcw() {
    var tmp = this.scw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('blacks');
    }
  }
  ycw() {
    var tmp = this.tcw_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('whites');
    }
  }
  za7(_this__u8e3s4, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_sceneMain__5xvlzl.bind(VOID, _this__u8e3s4, this), $completion);
  }
  wcw() {
    this.dcx().vai();
    this.zcw().vai();
    this.ccx().vai();
    var wonPlayer = ChessBoard__isCheckMate_impl_vr5fps_0(this.lcw_1);
    if (!(wonPlayer == null)) {
      // Inline function 'korlibs.korge.input.onClick' call
      // Inline function 'korlibs.korge.view.solidRect' call
      var this_0 = this.dcx();
      var size = Size2D.j26(this.fa9(), this.ga9());
      var color = Colors_getInstance().f3y_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_1 = SolidRect.kch(size, color);
      // Inline function 'kotlin.apply' call
      var this_2 = addTo(this_1, this_0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
      var handler = GameScene$redrawBoard$lambda(this);
      // Inline function 'korlibs.korge.input.doMouseEvent' call
      var prop = click$factory_2();
      var tmp1_safe_receiver = this_2 == null ? null : this_2.gaj();
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var n = 0;
        while (n < tmp1_safe_receiver.e1()) {
          // Inline function 'korlibs.korge.input.doMouseEvent.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
          var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
          if (tmp1_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp = prop.get(tmp1_safe_receiver_0);
            tmp.p1v(GameScene$redrawBoard$lambda_0(handler));
          }
        }
      }
      // Inline function 'korlibs.korge.view.filter.filters' call
      var tmp0_$receiver = this.dcx();
      var tmp1_text = 'Player ' + toString_1(wonPlayer) + '\nWON';
      var tmp2_alignment = Companion_getInstance().a4w_1;
      // Inline function 'korlibs.korge.view.text' call
      var color_0 = Colors_getInstance().q43_1;
      var font = get_DefaultTtfFontAsBitmap();
      var renderer = get_DefaultStringTextRenderer();
      var autoScaling = Companion_instance_0.ocl_1;
      // Inline function 'korlibs.korge.view.addTo' call
      var this_3 = Text.rcl(tmp1_text, numberToDouble(128.0), color_0, font, tmp2_alignment, renderer, autoScaling, null, null);
      // Inline function 'kotlin.apply' call
      var this_4 = addTo(this_3, tmp0_$receiver);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.view.text.<anonymous>' call
      var this_5 = centerOn(this_4, this.xa2());
      var filters = [new DropshadowFilter()];
      var filterScale = get_filterScale(this_5);
      // Inline function 'korlibs.korge.view.filter.filters' call
      var filters_0 = toList(filters);
      var filterScale_0 = numberToDouble(filterScale);
      set_filter(this_5, Companion_instance_1.oco(null, filters_0));
      set_filterScale(this_5, numberToDouble(filterScale_0));
      this.mcw_1 = null;
    }
    // Inline function 'ChessBoard.each' call
    var this_6 = this.lcw_1;
    // Inline function 'korlibs.datastructure.each' call
    var this_7 = _ChessBoard___get_array__impl__75hq55(this_6);
    var inductionVariable = 0;
    var last = this_7.o2i();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this_7.n2i();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'ChessBoard.each.<anonymous>' call
            var v = this_7.w2i(x, y);
            // Inline function 'GameScene.redrawBoard.<anonymous>' call
            var piecePos = Vector2I.h2f(x, y);
            var v_0 = Companion_getInstance_7().ucu(v);
            // Inline function 'korlibs.korge.view.image' call
            var this_8 = this.ccx();
            var texture = redrawBoard$getImage(v_0, this);
            var anchor = Companion_getInstance_0().b24_1;
            // Inline function 'korlibs.korge.view.addTo' call
            var this_9 = Image.rb4(texture, anchor);
            // Inline function 'kotlin.apply' call
            var this_10 = addTo(this_9, this_8);
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.korge.view.image.<anonymous>' call
            var tmp_0 = get_centered(this_10);
            // Inline function 'korlibs.math.geom.Vector2D.plus' call
            var this_11 = times(toDouble(piecePos), Size2D.j26(128, 128));
            var that = Vector2D.y27(64, 64);
            var tmp$ret$17 = Vector2D.s24(this_11.q24_1 + that.q24_1, this_11.r24_1 + that.r24_1);
            var tmp_1 = scale(xy_0(tmp_0, tmp$ret$17), 0.9);
            var tmp0_subject = this.mcw_1;
            var image = alpha(tmp_1, tmp0_subject == null ? 1.0 : equals(tmp0_subject, v_0.zcu()) ? 1.0 : 0.5);
            if (equals(v_0.zcu(), this.mcw_1)) {
              // Inline function 'korlibs.korge.input.mouse' call
              // Inline function 'kotlin.run' call
              // Inline function 'kotlin.contracts.contract' call
              get_mouse(image);
              draggable(image, VOID, VOID, GameScene$redrawBoard$lambda_1(this, v_0, piecePos, image));
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class main$slambda {
  d9f($this$Korge, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$Korge), $completion);
  }
  od(p1, $completion) {
    return this.d9f(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  }
}
//endregion
var KR_instance;
function KR_getInstance() {
  return KR_instance;
}
var KRGfx_instance;
function KRGfx_getInstance() {
  return KRGfx_instance;
}
function _TypedAtlas___init__impl__rehbr4(__file) {
  return __file;
}
function _TypedAtlas___get___file__impl__ebjt37($this) {
  return $this;
}
function *_generator_read__qih2oe($this, $completion) {
  var tmp = readAtlas(_TypedAtlas___get___file__impl__ebjt37($this), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new AtlasGfxChessShadowAtlas(_AtlasGfxChessShadowAtlas___init__impl__5t4ypk(tmp));
}
function TypedAtlas__read_impl_sgryfq($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, $this), $completion);
}
function _AtlasGfxChessShadowAtlas___init__impl__5t4ypk(__atlas) {
  return __atlas;
}
function _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this) {
  return $this;
}
function _AtlasGfxChessShadowAtlas___get_b_bishop__impl__g2ykt3($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('b_bishop.png');
}
function _AtlasGfxChessShadowAtlas___get_b_king__impl__ws42yr($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('b_king.png');
}
function _AtlasGfxChessShadowAtlas___get_b_knight__impl__v837jt($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('b_knight.png');
}
function _AtlasGfxChessShadowAtlas___get_b_pawn__impl__9jpl3o($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('b_pawn.png');
}
function _AtlasGfxChessShadowAtlas___get_b_queen__impl__llailc($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('b_queen.png');
}
function _AtlasGfxChessShadowAtlas___get_b_rook__impl__wui83p($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('b_rook.png');
}
function _AtlasGfxChessShadowAtlas___get_square_brown_dark__impl__jef9yk($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('square brown dark.png');
}
function _AtlasGfxChessShadowAtlas___get_square_brown_light__impl__aobxdy($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('square brown light.png');
}
function _AtlasGfxChessShadowAtlas___get_w_bishop__impl__sl8g5w($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('w_bishop.png');
}
function _AtlasGfxChessShadowAtlas___get_w_king__impl__7dqhle($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('w_king.png');
}
function _AtlasGfxChessShadowAtlas___get_w_knight__impl__4v66jo($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('w_knight.png');
}
function _AtlasGfxChessShadowAtlas___get_w_pawn__impl__um4zgh($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('w_pawn.png');
}
function _AtlasGfxChessShadowAtlas___get_w_queen__impl__fx4963($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('w_queen.png');
}
function _AtlasGfxChessShadowAtlas___get_w_rook__impl__7bccgg($this) {
  return _AtlasGfxChessShadowAtlas___get___atlas__impl__qw5hqa($this).yh('w_rook.png');
}
function AtlasGfxChessShadowAtlas__toString_impl_2uvypk($this) {
  return 'AtlasGfxChessShadowAtlas(__atlas=' + toString($this) + ')';
}
function AtlasGfxChessShadowAtlas__hashCode_impl_om1vif($this) {
  return hashCode($this);
}
function AtlasGfxChessShadowAtlas__equals_impl_lio65n($this, other) {
  if (!(other instanceof AtlasGfxChessShadowAtlas))
    return false;
  var tmp0_other_with_cast = other instanceof AtlasGfxChessShadowAtlas ? other.gcu_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var ChessPieceKind_PAWN_instance;
var ChessPieceKind_BISHOP_instance;
var ChessPieceKind_KNIGHT_instance;
var ChessPieceKind_ROOK_instance;
var ChessPieceKind_QUEEN_instance;
var ChessPieceKind_KING_instance;
var Companion_instance_2;
function Companion_getInstance_6() {
  ChessPieceKind_initEntries();
  if (Companion_instance_2 === VOID)
    new Companion();
  return Companion_instance_2;
}
function values() {
  return [ChessPieceKind_PAWN_getInstance(), ChessPieceKind_BISHOP_getInstance(), ChessPieceKind_KNIGHT_getInstance(), ChessPieceKind_ROOK_getInstance(), ChessPieceKind_QUEEN_getInstance(), ChessPieceKind_KING_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var ChessPieceKind_entriesInitialized;
function ChessPieceKind_initEntries() {
  if (ChessPieceKind_entriesInitialized)
    return Unit_instance;
  ChessPieceKind_entriesInitialized = true;
  ChessPieceKind_PAWN_instance = new ChessPieceKind('PAWN', 0, _Char___init__impl__6a9atx(80), 0);
  ChessPieceKind_BISHOP_instance = new ChessPieceKind('BISHOP', 1, _Char___init__impl__6a9atx(66), 1);
  ChessPieceKind_KNIGHT_instance = new ChessPieceKind('KNIGHT', 2, _Char___init__impl__6a9atx(75), 2);
  ChessPieceKind_ROOK_instance = new ChessPieceKind('ROOK', 3, _Char___init__impl__6a9atx(82), 3);
  ChessPieceKind_QUEEN_instance = new ChessPieceKind('QUEEN', 4, _Char___init__impl__6a9atx(81), 4);
  ChessPieceKind_KING_instance = new ChessPieceKind('KING', 5, _Char___init__impl__6a9atx(78), 5);
  Companion_getInstance_6();
}
var $ENTRIES;
var ChessPlayer_BLACK_instance;
var ChessPlayer_WHITE_instance;
function values_0() {
  return [ChessPlayer_BLACK_getInstance(), ChessPlayer_WHITE_getInstance()];
}
var ChessPlayer_entriesInitialized;
function ChessPlayer_initEntries() {
  if (ChessPlayer_entriesInitialized)
    return Unit_instance;
  ChessPlayer_entriesInitialized = true;
  ChessPlayer_BLACK_instance = new ChessPlayer('BLACK', 0);
  ChessPlayer_WHITE_instance = new ChessPlayer('WHITE', 1);
}
var Companion_instance_3;
function Companion_getInstance_7() {
  if (Companion_instance_3 === VOID)
    new Companion_0();
  return Companion_instance_3;
}
function createDefault$getY(player, y) {
  var tmp;
  switch (player.l3_1) {
    case 0:
      tmp = y;
      break;
    case 1:
      tmp = 7 - y | 0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function _ChessBoard___init__impl__tmwo79(array) {
  return array;
}
function _ChessBoard___get_array__impl__75hq55($this) {
  return $this;
}
function _ChessBoard___get_width__impl__55d7iy($this) {
  return _ChessBoard___get_array__impl__75hq55($this).n2i();
}
function _ChessBoard___get_height__impl__mtlxk9($this) {
  return _ChessBoard___get_array__impl__75hq55($this).o2i();
}
function ChessBoard__get_impl_xzfv5p($this, x, y) {
  return Companion_getInstance_7().ucu(_ChessBoard___get_array__impl__75hq55($this).n27(x, y));
}
function ChessBoard__get_impl_xzfv5p_0($this, p) {
  return ChessBoard__get_impl_xzfv5p($this, p.e2f_1, p.f2f_1);
}
var Companion_instance_4;
function Companion_getInstance_8() {
  return Companion_instance_4;
}
function ChessBoard__withMovement_impl_a0a502($this, oldPos, newPos) {
  var newArray = _ChessBoard___get_array__impl__75hq55($this).kx();
  var cell = newArray.t2i(oldPos);
  newArray.v2i(oldPos, Companion_getInstance_7().tcu_1.vcu_1);
  newArray.v2i(newPos, cell);
  return _ChessBoard___init__impl__tmwo79(newArray);
}
function ChessBoard__toString_impl_odpisb($this) {
  var tmp = until(0, _ChessBoard___get_height__impl__mtlxk9($this));
  return joinToString(tmp, '\n', VOID, VOID, VOID, VOID, ChessBoard$toString$lambda($this));
}
function ChessBoard__inBoard_impl_ub543y($this, pos) {
  var tmp;
  var containsArg = pos.e2f_1;
  if (0 <= containsArg ? containsArg <= 7 : false) {
    var containsArg_0 = pos.f2f_1;
    tmp = 0 <= containsArg_0 ? containsArg_0 <= 7 : false;
  } else {
    tmp = false;
  }
  return tmp;
}
function ChessBoard__validMovementPosition_impl_avojl($this, oldPos, newPos) {
  return ChessBoard__inBoard_impl_ub543y($this, newPos) && !equals(ChessBoard__get_impl_xzfv5p_0($this, newPos).zcu(), ChessBoard__get_impl_xzfv5p_0($this, oldPos).zcu());
}
function ChessBoard__availableMovements_impl_kr2zf0($this, oldPos, acceptCheck) {
  var piece = ChessBoard__get_impl_xzfv5p_0($this, oldPos);
  var player = piece.zcu();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filter' call
  var tmp;
  if (piece instanceof Empty) {
    return emptySet();
  } else {
    if (piece instanceof Piece) {
      var tmp_0;
      switch (piece.acv_1.l3_1) {
        case 0:
          // Inline function 'kotlin.collections.buildList' call

          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'kotlin.collections.buildListInternal' call

          // Inline function 'kotlin.apply' call

          var this_0 = ArrayList.h1();
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'ChessBoard.availableMovements.<anonymous>' call

          var tmp_1;
          switch (piece.bcv_1.l3_1) {
            case 0:
              tmp_1 = Vector2I.h2f(0, 1);
              break;
            case 1:
              tmp_1 = Vector2I.h2f(0, -1);
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }

          var dir = tmp_1;
          var tmp_2;
          switch (piece.bcv_1.l3_1) {
            case 0:
              tmp_2 = oldPos.f2f_1 === 1;
              break;
            case 1:
              tmp_2 = oldPos.f2f_1 === 6;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }

          var isInitialPosition = tmp_2;
          availableMovements$_anonymous_$addIfEmpty_s16jrj($this, this_0, oldPos.j2i(dir));
          if (isInitialPosition) {
            // Inline function 'korlibs.math.geom.Vector2F.times' call
            // Inline function 'korlibs.math.geom.Vector2F.times' call
            // Inline function 'korlibs.math.geom.Vector2F.times' call
            var this_1 = toFloat(dir);
            var tmp$ret$2 = Vector2F.d2i(this_1.b2i_1 * 2, this_1.c2i_1 * 2);
            availableMovements$_anonymous_$addIfEmpty_s16jrj($this, this_0, oldPos.j2i(toInt(tmp$ret$2)));
          }

          var tmp_3 = oldPos.j2i(dir).j2i(Vector2I.h2f(-1, 0));
          availableMovements$_anonymous_$addHasPlayer_29d6x2($this, this_0, tmp_3, player == null ? null : player.qcu());
          var tmp_4 = oldPos.j2i(dir).j2i(Vector2I.h2f(1, 0));
          availableMovements$_anonymous_$addHasPlayer_29d6x2($this, this_0, tmp_4, player == null ? null : player.qcu());
          tmp_0 = this_0.r7();
          break;
        case 2:
          tmp_0 = listOf([oldPos.g2f(Vector2I.h2f(-1, -2)), oldPos.g2f(Vector2I.h2f(1, -2)), oldPos.g2f(Vector2I.h2f(-1, 2)), oldPos.g2f(Vector2I.h2f(1, 2)), oldPos.g2f(Vector2I.h2f(-2, -1)), oldPos.g2f(Vector2I.h2f(2, -1)), oldPos.g2f(Vector2I.h2f(-2, 1)), oldPos.g2f(Vector2I.h2f(2, 1))]);
          break;
        case 1:
        case 3:
        case 4:
        case 5:
          // Inline function 'kotlin.collections.buildList' call

          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'kotlin.collections.buildListInternal' call

          // Inline function 'kotlin.apply' call

          var this_2 = ArrayList.h1();
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'ChessBoard.availableMovements.<anonymous>' call

          var bishopDirs = listOf([Vector2I.h2f(-1, -1), Vector2I.h2f(1, -1), Vector2I.h2f(-1, 1), Vector2I.h2f(1, 1)]);
          var rookDirs = listOf([Vector2I.h2f(-1, 0), Vector2I.h2f(0, -1), Vector2I.h2f(1, 0), Vector2I.h2f(0, 1)]);
          var extent = piece.acv_1.equals(ChessPieceKind_KING_getInstance()) ? 1 : 7;
          var tmp_5;
          switch (piece.acv_1.l3_1) {
            case 1:
              tmp_5 = bishopDirs;
              break;
            case 3:
              tmp_5 = rookDirs;
              break;
            case 5:
            case 4:
              tmp_5 = plus(bishopDirs, rookDirs);
              break;
            default:
              get_unreachable();
              break;
          }

          var dirs = tmp_5;
          var _iterator__ex2g4s = dirs.a1();
          while (_iterator__ex2g4s.b1()) {
            var dir_0 = _iterator__ex2g4s.c1();
            var inductionVariable = 1;
            if (inductionVariable <= extent)
              $l$loop_0: do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                // Inline function 'korlibs.math.geom.Vector2F.times' call
                var this_3 = toFloat(dir_0);
                var scale = n;
                var tmp$ret$6 = Vector2F.d2i(this_3.b2i_1 * scale, this_3.c2i_1 * scale);
                var newPos = oldPos.j2i(toInt(tmp$ret$6));
                if (!ChessBoard__validMovementPosition_impl_avojl($this, oldPos, newPos))
                  break $l$loop_0;
                this_2.h(newPos);
                if (!equals(ChessBoard__get_impl_xzfv5p_0($this, newPos), Companion_getInstance_7().tcu_1))
                  break $l$loop_0;
              }
               while (!(n === extent));
          }

          tmp_0 = this_2.r7();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      noWhenBranchMatchedException();
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var this_4 = tmp;
  var destination = ArrayList.h1();
  var tmp0_iterator = this_4.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'ChessBoard.availableMovements.<anonymous>' call
    if (ChessBoard__validMovementPosition_impl_avojl($this, oldPos, element)) {
      destination.h(element);
    }
  }
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList.h1();
  var tmp0_iterator_0 = destination.a1();
  while (tmp0_iterator_0.b1()) {
    var element_0 = tmp0_iterator_0.c1();
    // Inline function 'ChessBoard.availableMovements.<anonymous>' call
    if (acceptCheck ? true : !ChessBoard__isCheck_impl_3foegb(ChessBoard__withMovement_impl_a0a502($this, oldPos, element_0), player) && !equals(ChessBoard__get_impl_xzfv5p_0($this, element_0).ycu(), ChessPieceKind_KING_getInstance())) {
      destination_0.h(element_0);
    }
  }
  return toSet(destination_0);
}
function ChessBoard__availableMovements$default_impl_3zy8un($this, oldPos, acceptCheck, $super) {
  acceptCheck = acceptCheck === VOID ? false : acceptCheck;
  var tmp;
  if ($super === VOID) {
    tmp = ChessBoard__availableMovements_impl_kr2zf0($this, oldPos, acceptCheck);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new ChessBoard(tmp_0)).gcv.call(new ChessBoard($this), oldPos, acceptCheck);
  }
  return tmp;
}
function ChessBoard__isCheckMate_impl_vr5fps($this, player) {
  if (player == null)
    return false;
  // Inline function 'ChessBoard.each' call
  // Inline function 'korlibs.datastructure.each' call
  var this_0 = _ChessBoard___get_array__impl__75hq55($this);
  var inductionVariable = 0;
  var last = this_0.o2i();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this_0.n2i();
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'ChessBoard.each.<anonymous>' call
          var v = this_0.w2i(x, y);
          // Inline function 'ChessBoard.isCheckMate.<anonymous>' call
          var pos = Vector2I.h2f(x, y);
          var v_0 = Companion_getInstance_7().ucu(v);
          if (equals(v_0.zcu(), player)) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!ChessBoard__availableMovements_impl_kr2zf0($this, pos, false).g1()) {
              return false;
            }
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
function ChessBoard__isCheck_impl_3foegb($this, player) {
  if (player == null)
    return false;
  // Inline function 'ChessBoard.each' call
  // Inline function 'korlibs.datastructure.each' call
  var this_0 = _ChessBoard___get_array__impl__75hq55($this);
  var inductionVariable = 0;
  var last = this_0.o2i();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this_0.n2i();
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'ChessBoard.each.<anonymous>' call
          var v = this_0.w2i(x, y);
          // Inline function 'ChessBoard.isCheck.<anonymous>' call
          var pos = Vector2I.h2f(x, y);
          var v_0 = Companion_getInstance_7().ucu(v);
          if (!equals(v_0.zcu(), player)) {
            var _iterator__ex2g4s = ChessBoard__availableMovements_impl_kr2zf0($this, pos, true).a1();
            while (_iterator__ex2g4s.b1()) {
              var newPos = _iterator__ex2g4s.c1();
              var newCell = ChessBoard__get_impl_xzfv5p_0($this, newPos);
              if (equals(newCell.ycu(), ChessPieceKind_KING_getInstance()) && equals(newCell.zcu(), player)) {
                return true;
              }
            }
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return false;
}
function ChessBoard__isCheckMate_impl_vr5fps_0($this) {
  var indexedObject = values_0();
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var player = indexedObject[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    if (ChessBoard__isCheckMate_impl_vr5fps($this, player))
      return player;
  }
  return null;
}
function ChessBoard__hashCode_impl_2mjlzg($this) {
  return $this.hashCode();
}
function ChessBoard__equals_impl_5zlns($this, other) {
  if (!(other instanceof ChessBoard))
    return false;
  var tmp0_other_with_cast = other instanceof ChessBoard ? other.fcv_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function availableMovements$_anonymous_$addIfEmpty_s16jrj(this$0, $this_buildList, pos) {
  if (ChessBoard__inBoard_impl_ub543y(this$0, pos) && ChessBoard__get_impl_xzfv5p_0(this$0, pos).xcu()) {
    $this_buildList.h(pos);
  }
}
function availableMovements$_anonymous_$addHasPlayer_29d6x2(this$0, $this_buildList, pos, player) {
  if (ChessBoard__inBoard_impl_ub543y(this$0, pos) && equals(ChessBoard__get_impl_xzfv5p_0(this$0, pos).zcu(), player)) {
    $this_buildList.h(pos);
  }
}
function ChessBoard$toString$lambda$lambda(this$0, $y) {
  return function (x) {
    return toString(ChessBoard__get_impl_xzfv5p(this$0, x, $y));
  };
}
function ChessBoard$toString$lambda(this$0) {
  return function (y) {
    var tmp = until(0, _ChessBoard___get_width__impl__55d7iy(this$0));
    return joinToString(tmp, '', VOID, VOID, VOID, VOID, ChessBoard$toString$lambda$lambda(this$0, y));
  };
}
function ChessPieceKind_PAWN_getInstance() {
  ChessPieceKind_initEntries();
  return ChessPieceKind_PAWN_instance;
}
function ChessPieceKind_BISHOP_getInstance() {
  ChessPieceKind_initEntries();
  return ChessPieceKind_BISHOP_instance;
}
function ChessPieceKind_KNIGHT_getInstance() {
  ChessPieceKind_initEntries();
  return ChessPieceKind_KNIGHT_instance;
}
function ChessPieceKind_ROOK_getInstance() {
  ChessPieceKind_initEntries();
  return ChessPieceKind_ROOK_instance;
}
function ChessPieceKind_QUEEN_getInstance() {
  ChessPieceKind_initEntries();
  return ChessPieceKind_QUEEN_instance;
}
function ChessPieceKind_KING_getInstance() {
  ChessPieceKind_initEntries();
  return ChessPieceKind_KING_instance;
}
function ChessPlayer_BLACK_getInstance() {
  ChessPlayer_initEntries();
  return ChessPlayer_BLACK_instance;
}
function ChessPlayer_WHITE_getInstance() {
  ChessPlayer_initEntries();
  return ChessPlayer_WHITE_instance;
}
function main($completion) {
  var tmp = Size2D.j26(512, 512);
  var tmp_0 = Colors_getInstance().s4d('#2b2b2b');
  return Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, main$slambda_0(), $completion);
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.hcv_1.xa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.q9p_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.p9p_1.k9i_1.z62().x62(getKClass(SceneContainer), this_0).x62(getKClass(Resources), new Resources(this_0.q14(), this_0.p9p_1.r9q().e33_1, this_0.p9p_1.r9q()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.x62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_2().ra9_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.h2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.i2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.i63(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.p9p_1.k9i_1.b63(tmp_2, MainMenuScene$sceneMain$lambda$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.ta9(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function MainMenuScene$sceneMain$lambda$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'MainMenuScene.sceneMain.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function MainMenuScene$sceneMain$lambda$slambda_0(this$0) {
  var i = new MainMenuScene$sceneMain$lambda$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.u1n($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function MainMenuScene$sceneMain$lambda(this$0) {
  return function (it) {
    launch(this$0, VOID, VOID, MainMenuScene$sceneMain$lambda$slambda_0(this$0));
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda_1(this$0) {
  return function (it) {
    this$0.ka5().r8i();
    return Unit_instance;
  };
}
function MainMenuScene$sceneMain$lambda_2($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, it, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.scv_1.xa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.q9p_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(MainMenuScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.p9p_1.k9i_1.z62().x62(getKClass(SceneContainer), this_0).x62(getKClass(Resources), new Resources(this_0.q14(), this_0.p9p_1.r9q().e33_1, this_0.p9p_1.r9q()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.x62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new MainMenuScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_2().ra9_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.h2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.i2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.i63(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.p9p_1.k9i_1.b63(tmp_2, GameScene$sceneMain$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.ta9(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function GameScene$sceneMain$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'GameScene.sceneMain.<anonymous>.<anonymous>.<anonymous>' call
    return new MainMenuScene();
  };
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.tcv_1($this.ucv_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var this_0 = $this.vcv_1.xa2();
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = this_0.q9p_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(MainMenuScene);
  var injects_0 = injects.slice();
  var sceneInjector = this_0.p9p_1.k9i_1.z62().x62(getKClass(SceneContainer), this_0).x62(getKClass(Resources), new Resources(this_0.q14(), this_0.p9p_1.r9q().e33_1, this_0.p9p_1.r9q()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp = getKClassFromExpression(inject);
    sceneInjector.x62(isInterface(tmp, KClass) ? tmp : THROW_CCE(), inject);
  }
  // Inline function 'GameScene.redrawBoard.<anonymous>.<anonymous>.<anonymous>' call
  var newScene = new MainMenuScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_2().ra9_1;
  var level = Level_INFO_getInstance();
  var tmp_0;
  if (this_1.h2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$3 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.i2t(level, tmp$ret$3);
    tmp_0 = Unit_instance;
  }
  if (true) {
    newScene.i63(sceneInjector);
    var tmp_1 = getKClassFromExpression(newScene);
    var tmp_2 = isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE();
    this_0.p9p_1.k9i_1.b63(tmp_2, GameScene$redrawBoard$lambda$slambda$lambda(sceneInjector));
  }
  var tmp_3 = this_0.ta9(newScene, time, transition, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function GameScene$redrawBoard$lambda$slambda$lambda($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'GameScene.redrawBoard.<anonymous>.<anonymous>.<anonymous>' call
    return new MainMenuScene();
  };
}
function *_generator_sceneMain__5xvlzl(_this__u8e3s4, $this, $completion) {
  var tmp = $this;
  // Inline function 'korlibs.korge.view.solidRect' call
  var width = _this__u8e3s4.n2i();
  var height = _this__u8e3s4.o2i();
  var color = Colors_getInstance().f3y_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SolidRect.kch(Size2D.a2e(width, height), color);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
  tmp.ucw_1 = addTo(this_0, _this__u8e3s4);
  var tmp_0 = $this;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_1 = Container.ia5(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  tmp_0.ncw_1 = addTo(this_1, _this__u8e3s4);
  var tmp_1 = $this;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_2 = Container.ia5(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  tmp_1.ocw_1 = addTo(this_2, _this__u8e3s4);
  var tmp_2 = $this;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_3 = Container.ia5(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  tmp_2.pcw_1 = addTo(this_3, _this__u8e3s4);
  var tmp_3 = $this;
  // Inline function 'korlibs.korge.view.container' call
  // Inline function 'korlibs.korge.view.addTo' call
  var this_4 = Container.ia5(false);
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  tmp_3.qcw_1 = addTo(this_4, _this__u8e3s4);
  var tmp_4 = $this;
  // Inline function 'korlibs.korge.view.filter.filters' call
  // Inline function 'korlibs.korge.view.text' call
  var text = 'position';
  var color_0 = Colors_getInstance().c3y_1;
  var font = get_DefaultTtfFontAsBitmap();
  var alignment = Companion_getInstance().n4v_1;
  var renderer = get_DefaultStringTextRenderer();
  var autoScaling = Companion_instance_0.ocl_1;
  // Inline function 'korlibs.korge.view.addTo' call
  var this_5 = Text.rcl(text, numberToDouble(64.0), color_0, font, alignment, renderer, autoScaling, null, null);
  // Inline function 'kotlin.apply' call
  var this_6 = addTo(this_5, _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.view.text.<anonymous>' call
  // Inline function 'korlibs.korge.view.filter.Companion.invoke' call
  Companion_getInstance_4();
  var shadowColor = RGBA__withAd_impl_cralao(Colors_getInstance().b3y_1, 0.75);
  var filters = [new DropshadowFilter(numberToDouble(1.0), numberToDouble(1.0), shadowColor, numberToDouble(1.0), true)];
  var filterScale = get_filterScale(this_6);
  // Inline function 'korlibs.korge.view.filter.filters' call
  var filters_0 = toList(filters);
  var filterScale_0 = numberToDouble(filterScale);
  set_filter(this_6, Companion_instance_1.oco(null, filters_0));
  set_filterScale(this_6, numberToDouble(filterScale_0));
  tmp_4.rcw_1 = this_6;
  var tmp_5 = TypedAtlas__read_impl_sgryfq(KR_instance.ecu().fcu(), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var images = tmp_5.gcu_1;
  var tmp_6 = $this;
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  tmp_6.scw_1 = listOf([_AtlasGfxChessShadowAtlas___get_b_pawn__impl__9jpl3o(images), _AtlasGfxChessShadowAtlas___get_b_bishop__impl__g2ykt3(images), _AtlasGfxChessShadowAtlas___get_b_knight__impl__v837jt(images), _AtlasGfxChessShadowAtlas___get_b_rook__impl__wui83p(images), _AtlasGfxChessShadowAtlas___get_b_queen__impl__llailc(images), _AtlasGfxChessShadowAtlas___get_b_king__impl__ws42yr(images)]);
  var tmp_7 = $this;
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  tmp_7.tcw_1 = listOf([_AtlasGfxChessShadowAtlas___get_w_pawn__impl__um4zgh(images), _AtlasGfxChessShadowAtlas___get_w_bishop__impl__sl8g5w(images), _AtlasGfxChessShadowAtlas___get_w_knight__impl__4v66jo(images), _AtlasGfxChessShadowAtlas___get_w_rook__impl__7bccgg(images), _AtlasGfxChessShadowAtlas___get_w_queen__impl__fx4963(images), _AtlasGfxChessShadowAtlas___get_w_king__impl__7dqhle(images)]);
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  var bgs = listOf([_AtlasGfxChessShadowAtlas___get_square_brown_dark__impl__jef9yk(images), _AtlasGfxChessShadowAtlas___get_square_brown_light__impl__aobxdy(images)]);
  var inductionVariable = 0;
  if (inductionVariable < 8)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < 8)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'kotlin.apply' call
          // Inline function 'korlibs.korge.view.xy' call
          // Inline function 'korlibs.korge.view.image' call
          var this_7 = $this.vcw();
          // Inline function 'korlibs.math.toInt' call
          var tmp$ret$33 = get_isEven(x + y | 0) ? 1 : 0;
          var texture = bgs.d1(tmp$ret$33);
          var anchor = Companion_getInstance_0().b24_1;
          // Inline function 'korlibs.korge.view.addTo' call
          var this_8 = Image.rb4(texture, anchor);
          // Inline function 'kotlin.apply' call
          var this_9 = addTo(this_8, this_7);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.korge.view.image.<anonymous>' call
          var x_0 = imul(128, x);
          var y_0 = imul(128, y);
          xy(this_9, numberToDouble(x_0), numberToDouble(y_0));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'GameScene.sceneMain.<anonymous>' call
        }
         while (inductionVariable_0 < 8);
    }
     while (inductionVariable < 8);
  $this.wcw();
  // Inline function 'korlibs.korge.ui.uiHorizontalStack' call
  // Inline function 'kotlin.apply' call
  var this_10 = addTo(UIHorizontalStack.zbg(null == null ? null : numberToDouble(null), numberToDouble(0.0), true), _this__u8e3s4);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'GameScene.sceneMain.<anonymous>' call
  // Inline function 'korlibs.korge.input.onClickSuspend' call
  // Inline function 'korlibs.korge.ui.uiButton' call
  var label = 'QUIT GAME';
  var size = Companion_getInstance_3().eao_1;
  // Inline function 'kotlin.apply' call
  var this_11 = addTo(UIButton.say(size, label, null), this_10);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.ui.uiButton.<anonymous>' call
  var handler = GameScene$sceneMain$slambda_0($this);
  // Inline function 'korlibs.korge.input.doMouseEventSuspend' call
  var prop = click$factory_1();
  // Inline function 'kotlin.js.getCoroutineContext' call
  var coroutineContext = $completion.kc();
  var tmp1_safe_receiver = this_11 == null ? null : this_11.gaj();
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp1_safe_receiver.e1()) {
      // Inline function 'korlibs.korge.input.doMouseEventSuspend.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var tmp0_safe_receiver = tmp1_safe_receiver.d1(_unary__edvuaz);
      var tmp1_safe_receiver_0 = tmp0_safe_receiver == null ? null : get_mouse(tmp0_safe_receiver);
      if (tmp1_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_8 = prop.get(tmp1_safe_receiver_0);
        tmp_8.p1v(GameScene$sceneMain$lambda(coroutineContext, tmp1_safe_receiver_0, handler));
      }
    }
  }
  return Unit_instance;
}
function redrawBoard$getImage(_this__u8e3s4, this$0) {
  var tmp;
  if (_this__u8e3s4 instanceof Empty) {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    tmp = get_Bitmaps_transparent();
  } else {
    if (_this__u8e3s4 instanceof Piece) {
      var tmp_0;
      switch (_this__u8e3s4.bcv_1.l3_1) {
        case 0:
          tmp_0 = this$0.xcw();
          break;
        case 1:
          tmp_0 = this$0.ycw();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var array = tmp_0;
      tmp = array.d1(_this__u8e3s4.acv_1.ncu_1);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
}
function GameScene$sceneMain$slambda_0(this$0) {
  var i = new GameScene$sceneMain$slambda(this$0);
  var l = function (it, $completion) {
    return i.a9w(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$sceneMain$lambda$slambda_0($handler, $it) {
  var i = new GameScene$sceneMain$lambda$slambda($handler, $it);
  var l = function ($completion) {
    return i.nd($completion);
  };
  l.$arity = 0;
  return l;
}
function GameScene$sceneMain$lambda($coroutineContext, $mouse, $handler) {
  return function (it) {
    var tmp0_elvis_lhs = $coroutineContext;
    var tmp = tmp0_elvis_lhs == null ? $mouse.s9x() : tmp0_elvis_lhs;
    launchImmediately(tmp, GameScene$sceneMain$lambda$slambda_0($handler, it));
    return Unit_instance;
  };
}
function GameScene$redrawBoard$lambda$slambda_0(this$0) {
  var i = new GameScene$redrawBoard$lambda$slambda(this$0);
  var l = function ($this$launch, $completion) {
    return i.u1n($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function GameScene$redrawBoard$lambda(this$0) {
  return function (it) {
    this$0.y5p().scl('CLICKED!');
    launch(this$0, VOID, VOID, GameScene$redrawBoard$lambda$slambda_0(this$0));
    return Unit_instance;
  };
}
function GameScene$redrawBoard$lambda_0($handler) {
  return function (it) {
    $handler(it);
    return Unit_instance;
  };
}
function GameScene$redrawBoard$lambda_1(this$0, $v, $piecePos, $image) {
  return function (it) {
    this$0.y5p().scl('PIECE: ' + toString($v) + ', piecePos=' + $piecePos.toString());
    var newPos = toInt_0(div(it.e9v_1, Size2D.j26(128, 128)));
    var tmp;
    try {
      tmp = ChessBoard__availableMovements$default_impl_3zy8un(this$0.lcw_1, $piecePos);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        this$0.y5p().scl('ERROR: ' + e.message);
        tmp_0 = emptyList();
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var validMovements = tmp;
    var isValidMovement = validMovements.u2(newPos);
    var tmp_1;
    if (it.p9t_1) {
      $image.acf(1000.0);
      this$0.zcw().vai();
      var _iterator__ex2g4s = validMovements.a1();
      while (_iterator__ex2g4s.b1()) {
        var movement = _iterator__ex2g4s.c1();
        var color = !ChessBoard__get_impl_xzfv5p_0(this$0.lcw_1, movement).xcu() ? Colors_getInstance().m3z_1 : Colors_getInstance().h40_1;
        // Inline function 'korlibs.korge.view.solidRect' call
        var this_0 = this$0.zcw();
        var color_0 = RGBA__withAd_impl_cralao(color, 0.25);
        // Inline function 'korlibs.korge.view.addTo' call
        var this_1 = SolidRect.kch(Size2D.j26(128, 128), color_0);
        // Inline function 'kotlin.apply' call
        var this_2 = addTo(this_1, this_0);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
        xy_0(this_2, times(toDouble(movement), Size2D.j26(128, 128)));
      }
      tmp_1 = Unit_instance;
    }
    var tmp_2;
    if (it.q9t_1) {
      var tmp_3;
      if (isValidMovement) {
        var tmp0_safe_receiver = this$0.mcw_1;
        this$0.acx(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qcu(), ChessBoard__withMovement_impl_a0a502(this$0.lcw_1, $piecePos, newPos));
        tmp_3 = Unit_instance;
      } else {
        this$0.wcw();
        tmp_3 = Unit_instance;
      }
      tmp_2 = tmp_3;
    }
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_3($this, $this$Korge, $completion) {
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var defaultTransition = withEasing(get_AlphaTransition(), get_EASE_IN_OUT_QUAD(Companion_getInstance_5()));
  var name = 'sceneContainer';
  var size = Companion_getInstance_1().b2g_1;
  // Inline function 'korlibs.korge.scene.sceneContainer' call
  var tmp = views($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var views_0 = tmp;
  var width = size.dl();
  var height = size.el();
  var rwidth = width;
  var rheight = height;
  if (width === 0.0 && height === 0.0) {
    var tmp_0 = findFirstAscendant($this$Korge, main$slambda$lambda);
    var base = (tmp_0 == null ? true : tmp_0 instanceof FixedSizeContainer) ? tmp_0 : null;
    var tmp1_elvis_lhs = base == null ? null : base.n2i();
    rwidth = tmp1_elvis_lhs == null ? views_0.u9j_1.n2i() : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = base == null ? null : base.o2i();
    rheight = tmp3_elvis_lhs == null ? views_0.u9j_1.o2i() : tmp3_elvis_lhs;
  }
  // Inline function 'korlibs.korge.view.addTo' call
  var this_0 = SceneContainer.v9p(views_0, defaultTransition, name, Size2D.a2e(rwidth, rheight));
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.korge.scene.sceneContainer.<anonymous>' call
  var sceneContainer = addTo(this_0, $this$Korge);
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var injects = [];
  // Inline function 'korlibs.time.seconds' call
  // Inline function 'korlibs.time.seconds' call
  var time = toDuration(0, DurationUnit_SECONDS_getInstance());
  var transition = sceneContainer.q9p_1;
  // Inline function 'korlibs.korge.scene.SceneContainer.changeTo' call
  var clazz = getKClass(GameScene);
  var injects_0 = injects.slice();
  var sceneInjector = sceneContainer.p9p_1.k9i_1.z62().x62(getKClass(SceneContainer), sceneContainer).x62(getKClass(Resources), new Resources(sceneContainer.q14(), sceneContainer.p9p_1.r9q().e33_1, sceneContainer.p9p_1.r9q()));
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < injects_0.length) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var inject = injects_0[_unary__edvuaz];
    var tmp_1 = getKClassFromExpression(inject);
    sceneInjector.x62(isInterface(tmp_1, KClass) ? tmp_1 : THROW_CCE(), inject);
  }
  // Inline function 'main.<anonymous>.<anonymous>' call
  var newScene = new GameScene();
  // Inline function 'korlibs.logger.Logger.info' call
  var this_1 = Companion_getInstance_2().ra9_1;
  var level = Level_INFO_getInstance();
  var tmp_2;
  if (this_1.h2t(level)) {
    // Inline function 'korlibs.korge.scene.SceneContainer.changeTo.<anonymous>' call
    var tmp$ret$8 = 'Changing scene to... ' + toString(clazz) + ' ... ' + toString(newScene);
    this_1.i2t(level, tmp$ret$8);
    tmp_2 = Unit_instance;
  }
  if (true) {
    newScene.i63(sceneInjector);
    var tmp_3 = getKClassFromExpression(newScene);
    var tmp_4 = isInterface(tmp_3, KClass) ? tmp_3 : THROW_CCE();
    sceneContainer.p9p_1.k9i_1.b63(tmp_4, main$slambda$lambda_0(sceneInjector));
  }
  var tmp_5 = sceneContainer.ta9(newScene, time, transition, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function main$slambda$lambda(it) {
  return it instanceof FixedSizeContainer;
}
function main$slambda$lambda_0($sceneInjector) {
  return function ($this$mapPrototype) {
    // Inline function 'main.<anonymous>.<anonymous>' call
    return new GameScene();
  };
}
function main$slambda_0() {
  var i = new main$slambda();
  var l = function ($this$Korge, $completion) {
    return i.d9f($this$Korge, $completion);
  };
  l.$arity = 1;
  return l;
}
function click$factory() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.h9w_1;
  }, null);
}
function click$factory_0() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.h9w_1;
  }, null);
}
function click$factory_1() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.h9w_1;
  }, null);
}
function click$factory_2() {
  return getPropertyCallableRef('click', 1, KProperty1, function (receiver) {
    return receiver.h9w_1;
  }, null);
}
function mainWrapper() {
  startCoroutineUninterceptedOrReturnGeneratorVersion(main, get_EmptyContinuation());
}
//region block: post-declaration
initMetadataForInterface(KR, 'KR');
protoOf(KR_0).ecu = get_gfx;
initMetadataForObject(KR_0, 'KR', VOID, VOID, [KR]);
initMetadataForObject(KRGfx, 'KRGfx');
initMetadataForClass(AtlasGfxChessShadowAtlas, 'AtlasGfxChessShadowAtlas');
initMetadataForCompanion(Companion);
initMetadataForClass(ChessPieceKind, 'ChessPieceKind');
initMetadataForClass(ChessPlayer, 'ChessPlayer');
initMetadataForCompanion(Companion_0);
initMetadataForInterface(ChessCell, 'ChessCell');
protoOf(Empty).xcu = get_isEmpty;
protoOf(Empty).ycu = get_kind;
protoOf(Empty).zcu = get_player;
initMetadataForClass(Empty, 'Empty', Empty, VOID, [ChessCell]);
protoOf(Piece).xcu = get_isEmpty;
initMetadataForClass(Piece, 'Piece', VOID, VOID, [ChessCell]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(ChessBoard, 'ChessBoard');
initMetadataForLambda(MainMenuScene$sceneMain$lambda$slambda, VOID, VOID, [1]);
initMetadataForClass(MainMenuScene, 'MainMenuScene', MainMenuScene, VOID, VOID, [0]);
initMetadataForLambda(GameScene$sceneMain$slambda, VOID, VOID, [1]);
initMetadataForLambda(GameScene$sceneMain$lambda$slambda, VOID, VOID, [0]);
initMetadataForLambda(GameScene$redrawBoard$lambda$slambda, VOID, VOID, [1]);
initMetadataForClass(GameScene, 'GameScene', GameScene, VOID, VOID, [0]);
initMetadataForLambda(main$slambda, VOID, VOID, [1]);
//endregion
//region block: init
KR_instance = new KR_0();
KRGfx_instance = new KRGfx();
Companion_instance_4 = new Companion_1();
//endregion
mainWrapper();
